const newButtonParamsFallback = (value, fallback) => {
  return value ? value : fallback;
};

const formatLink = (link) => {
  try {
    return JSON.parse(link);
  } catch {
    return link || "";
  }
};

export const formatEmoji = (emoji) => {
  try {
    return JSON.parse(emoji);
  } catch {
    return emoji || {};
  }
};

export const formatData = (macroData) => {
  let buttonShadow;
  let isButtonShadowOn;

  if (macroData.buttonShadow) {
    const value = Number(macroData.buttonShadow);

    if (Number.isNaN(value)) {
      buttonShadow = macroData.buttonShadow;
      isButtonShadowOn =
        macroData.buttonShadow !== "none" && macroData.buttonShadow !== "inner";
    } else {
      buttonShadow = value;
      isButtonShadowOn = value !== 0;
    }
  }

  return {
    ...macroData,
    buttonIconHoverColor: newButtonParamsFallback(
      macroData.buttonIconHoverColor,
      macroData.buttonColor
    ),
    buttonFontHoverColor: newButtonParamsFallback(
      macroData.buttonFontHoverColor,
      macroData.buttonColor
    ),
    buttonBorderHoverColor: newButtonParamsFallback(
      macroData.buttonBorderHoverColor,
      macroData.buttonBorderColor
    ),
    buttonHoverColor: newButtonParamsFallback(
      macroData.buttonHoverColor,
      macroData.buttonColor
    ),
    buttonIconColor: newButtonParamsFallback(
      macroData.buttonIconColor,
      macroData.buttonFontColor
    ),
    emojiEnabled:
      macroData.emojiEnabled === "true" || macroData.emojiEnabled === true,
    buttonType: macroData.buttonType || "text",
    buttonLink: formatLink(macroData?.buttonLink),
    buttonWidth: Number(macroData.buttonWidth),
    buttonRadius: Number(macroData.buttonRadius),
    buttonText: macroData.buttonText ?? "",
    buttonShadow,
    isButtonShadowOn,
    emoji: formatEmoji(macroData.emoji),
  };
};

const getCorrectIncrease = (size) => {
  switch (size) {
    case "small":
      return { width: 8, height: 7 };
    case "medium":
      return { width: 10, height: 9 };
    case "large":
      return { width: 12, height: 11 };
    default:
      return { width: 6, height: 5 };
  }
};

const getButtonElement = () =>
  document.getElementsByClassName("macrosuite-button")[0];

const doResizing = (
  element,
  resizeAccordingToShadow,
  sizeIncrease,
  setContainerHeight,
  isOldButton
) => {
  if (!element) return;

  const resize = () => {
    const width = Math.ceil(element.scrollWidth) + (sizeIncrease?.width || 0);
    const height = resizeAccordingToShadow
      ? Math.ceil(element.offsetHeight) + (sizeIncrease?.height || 0) + 5
      : Math.ceil(element.offsetHeight) + (isOldButton ? 5 : 0);

    window.AP.resize(`${width}px`, `${height}px`);

    if (resizeAccordingToShadow) {
      setContainerHeight(`${height}px`);
    }
  };

  resize();

  const observer = new ResizeObserver(() => {
    resize();
  });

  observer.observe(element);

  return observer;
};

export const resize = (buttonData, setContainerHeight, isOldButton) => {
  const buttonElement = getButtonElement();
  const sizeIncrease = getCorrectIncrease(buttonData.size);
  if (buttonElement) {
    doResizing(
      buttonElement,
      buttonData.resizeAccordingToShadow,
      sizeIncrease,
      setContainerHeight,
      isOldButton
    );
  }
};
